// extracted by mini-css-extract-plugin
module.exports = {"content":"collapse_content__5KpWT"};